// extracted by mini-css-extract-plugin
export default {"tooltip":"cursorTooltip_tooltip__DU8kR","active":"cursorTooltip_active__5D8BU"};